import { UserProfileModel } from "./user-profile.model";

export class UserModel {
    Id: number;
    Iata: string;
    EstadoSolicitud: number;
    NombreCompleto: string;
    IdentificacionTercero:string;
    NombreTercero:string;
    AreaNegocio:string;
    Cargo:string;
    Email: string;
    Aprobador?:string;
    FechaCreacion: Date;
    CreadoPor: string;
    FechaModificado?:Date;
    ModificadoPor?: string;
    Idp:string;    
    UserProfile:UserProfileModel[];
  
    UserModel() {
      this.Id = 0;
      this.Iata = "";
      this.Email = "";
      this.EstadoSolicitud = 2;
      this.NombreCompleto = "";
      this.NombreTercero = "";
      this.AreaNegocio = "";
      this.Cargo ="";
      this.Aprobador="";
      this.FechaCreacion = new Date;
      this.CreadoPor ="";
      this.ModificadoPor="";
      this.FechaModificado= new Date;  
      this.ModificadoPor ="";   
      this.Idp =""; 
      
    }
  }
